const useSectionData = ({ sections }) => {
  const _sections = sections;

  const getNumberOfAllSubsection = (section) => {
    return section.subSections.length;
  };

  const getNumberOfCompleteSubsection = (section) => {
    const numberCompleteSubsection = section.subSections.filter(({ complete }) => complete).length;
    return numberCompleteSubsection;
  };

  const getTotalTimeOfSection = (section) => {
    return section.subSections.reduce((a, b) => a + b.contentLength, 0);
  };

  return {
    data: _sections.map((section) => {
      return {
        ...section,
        numberAllSubsection: getNumberOfAllSubsection(section),
        numberComplatedSubsection: getNumberOfCompleteSubsection(section),
        totalTime: getTotalTimeOfSection(section),
      };
    }),
  };
};

export default useSectionData;
